import React from 'react';
import { RawEditor } from './RawEditor';
import type { AutocompleteProvider, IndentStyle } from '../types';

export interface HtmlSourceEditorProps {
  /** Current HTML content */
  value: string;
  /** Called when content changes */
  onChange?: (html: string) => void;
  /** Placeholder text */
  placeholder?: string;
  /** Additional CSS class */
  className?: string;
  /** Whether the editor is read-only */
  readOnly?: boolean;
  /** Autocomplete provider for Handlebars tags */
  autocompleteProvider?: AutocompleteProvider;
  /** Show friendly descriptions instead of {{variable}} syntax (default: false) */
  showDescriptions?: boolean;
  /** When true, allows any Handlebars syntax without provider validation (default: false) */
  allowFreeformHandlebars?: boolean;
  /** Indentation style: 'tab', '2space', or '4space' (default: 'tab') */
  indentStyle?: IndentStyle;
  /** Max height of the editor (e.g. "400px", "50vh"). When set, content scrolls. */
  maxHeight?: string;
}

/**
 * HTML source code editor with syntax highlighting and Handlebars autocomplete.
 * This is a convenience wrapper around RawEditor with language="html".
 */
export const HtmlSourceEditor: React.FC<HtmlSourceEditorProps> = ({
  placeholder = 'Enter HTML...',
  ...props
}) => {
  return (
    <RawEditor
      {...props}
      language="html"
      placeholder={placeholder}
    />
  );
};
